import { Inject, Injectable } from '@angular/core';
//import { Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import configData from "./../assets/data/config.json";

@Injectable()
export class AppConfig {

    private config: Object = null;
    private environment:    Object = null;

    constructor(private http: HttpClient,) {

    }

    /**
     * Use to get the data found in the second file (config file)
     */
    public getConfig(key: any) {
      if(configData) {
        return configData[key];
      } else {
        return '';
        // var con = setInterval(() => {
        //   if(this.config) {
        //     clearInterval(con);
        //   }
        // },100);
      }
    }

    /**
     * Use to get the data found in the first file (environment file)
     */
    public getEnv(key: any) {
        return this.environment[key];
    }

    /**
     * This method:
     *   a) Loads "environment.json" to get the current working environment (e.g.: 'production', 'development')
     *   b) Loads "config.[environment].json" to get all environment's variables (e.g.: 'config.development.json')
     */

    //  public getJSON(jsonURL): Observable<any> {
    //   return this.http.get(jsonURL);
    // }


     public load() {
      this.config = configData;
      // return new Promise((resolve, reject) => {
      //     this.getJSON('../assets/data/config.json').subscribe( (responseData:any) => {
      //         this.config = responseData;
      //         resolve(true);
      //     },
      //     (error:any) => {
      //       console.log('Configuration file "config.json" could not be read');
      //       resolve(true);
      //       return Observable.throw(error.error || 'Server error');
      //   });

      // });
  }
}